import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import Table from 'src/components/Table';
import TableCell from 'src/components/Table/TableCell';
import TableRow from '@mui/material/TableRow';
import { useTranslation } from 'react-i18next';
import DenominationRow from './DenominationRow';

const DenominationTable = ({
  className,
  denominations,
  handleOpenEdit,
  handleDelete,
  ...rest
}) => {
  const { t } = useTranslation();
  const openEdit = useCallback(
    location => () => {
      handleOpenEdit(location);
    },
    [handleOpenEdit]
  );

  const theads = useMemo(() => () => (
    <TableRow>
      <TableCell>{t('COMMON.DENOMINATION')}</TableCell>
      <TableCell>{t('COMMON.ACTION')}</TableCell>
    </TableRow>
  ));

  const tbody = useMemo(
    () => () => {
      return denominations.map(denomination => (
        <DenominationRow
          {...denomination}
          key={denomination.id}
          openEdit={openEdit(denomination)}
          handleDelete={handleDelete}
        />
      ));
    },
    [denominations]
  );

  return <Table tbody={tbody} theads={theads} {...rest} />;
};

DenominationTable.propTypes = {
  className: PropTypes.string,
  denominations: PropTypes.array.isRequired,
  handleOpenEdit: PropTypes.func,
  handleDelete: PropTypes.func
};

export default DenominationTable;
